import { useEffect, useState } from "react";
import {
  getNavDisplayConfig,
  getNseDisplaySession,
} from "utils/nseMarketSession";

const REFRESH_MS = 60_000;

const readSession = () => {
  const session = getNseDisplaySession();
  const nav = getNavDisplayConfig();
  return {
    isOpen: session.isOpen,
    label: session.isOpen ? "Market Live" : "Market Closed",
    tooltip: session.isOpen
      ? "NSE market is open"
      : nav.footnote || "Market closed",
  };
};

const useNseMarketSession = () => {
  const [market, setMarket] = useState(readSession);

  useEffect(() => {
    const refresh = () => setMarket(readSession());
    refresh();
    const timerId = window.setInterval(refresh, REFRESH_MS);
    return () => window.clearInterval(timerId);
  }, []);

  return market;
};

export default useNseMarketSession;
